import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import type { Session } from "@supabase/supabase-js";
import { useUserContext } from "../../../context/UserContext";
import { hasRole } from "../../../lib/auth";
import { ROUTES, signInPath } from "../../../route_paths";

interface UseInternalAuthResult {
  session: Session | null;
  signOut: () => Promise<void>;
}

/**
 * Auth guard for internal routes.
 * Redirects to /internal/login if:
 * - No active session
 * - Session user does not have the corpus.annotator role (or platform.admin)
 */
export function useInternalAuth(): UseInternalAuthResult {
  const { session, loading, signOut } = useUserContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!session || !hasRole(session.user, "corpus.annotator")) {
      navigate(signInPath(ROUTES.internal.annotation.path()), { replace: true });
    }
  }, [session, loading, navigate]);

  return {
    session,
    signOut,
  };
}
